import {
	SourceSystemAsrs,
	SourceSystemFlexnet,
	FlexnetHoldSystemId,
	AsrsHoldSystemId,
	PlantStatusFlexnetTitle,
	LpnLockingStatusTitle,
} from "lib/util/constants/index";

// eslint-disable-next-line no-restricted-syntax
export interface ContainmentTypeConfig {
	sourceSystem: string;
	hasHolds: boolean;
	sectorAutoSelected: boolean;
	autoSelectAllPlants: boolean;
	plantValidationRequired: boolean;
	showUploadContentType: boolean;
	hasUnmappedSerials: boolean;
	holdSystemName: string;
	holdSystemId: string;
	statusTableTitle: string;
	itemLabel: string;
	hasOverrideAlerts: boolean;
	usesLockPermissions: boolean;
}

export const ContainmentTypeConfigs: Record<string, ContainmentTypeConfig> = {
	[SourceSystemFlexnet]: {
		sourceSystem: SourceSystemFlexnet,
		hasHolds: true,
		sectorAutoSelected: false,
		autoSelectAllPlants: false,
		plantValidationRequired: true,
		showUploadContentType: false,
		hasUnmappedSerials: false,
		holdSystemName: "Flexnet",
		holdSystemId: FlexnetHoldSystemId,
		statusTableTitle: PlantStatusFlexnetTitle,
		itemLabel: "Serial",
		hasOverrideAlerts: false,
		usesLockPermissions: false,
	},
	// ASRS-LPN intake has no Product Number field on create (SITMP-7232).
	[SourceSystemAsrs]: {
		sourceSystem: SourceSystemAsrs,
		hasHolds: false,
		sectorAutoSelected: true,
		autoSelectAllPlants: true,
		plantValidationRequired: false,
		showUploadContentType: true,
		hasUnmappedSerials: true,
		holdSystemName: "ASRS",
		holdSystemId: AsrsHoldSystemId,
		statusTableTitle: LpnLockingStatusTitle,
		itemLabel: "LPN",
		hasOverrideAlerts: true,
		usesLockPermissions: true,
	},
};

export function GetContainmentTypeConfig(sourceSystem: string): ContainmentTypeConfig | undefined {
	return ContainmentTypeConfigs[sourceSystem];
}

/** Inputs for readonly Part Numbers / upload-content summary visibility. */
// eslint-disable-next-line no-restricted-syntax
export interface PartNumbersSummaryVisibility {
	typeConfig?: Pick<ContainmentTypeConfig, "showUploadContentType">;
	hasMultipleParts?: boolean;
	partNumber?: string | null;
	supplierDunsName?: string | null;
	uploadContentTypeLabel?: string | null;
}

/**
 * Whether the readonly Part Numbers card has anything meaningful to show
 * (ASRS upload-content type label, or FlexNet multi/single part / DUNS).
 */
export function ShouldShowPartNumbersSummary({
	typeConfig,
	hasMultipleParts = false,
	partNumber,
	supplierDunsName,
	uploadContentTypeLabel,
}: PartNumbersSummaryVisibility): boolean {
	if (typeConfig?.showUploadContentType) {
		return !!uploadContentTypeLabel;
	}
	return hasMultipleParts || !!partNumber || !!supplierDunsName;
}
